export default __webpack_public_path__ + "static/media/area-3.a5ecd751.png";